<template>
  <div class="scienceLoan">
    <!-- 背景介绍 -->
    <div class="Background_intro">
      <div class="container">
        <!-- 面包屑导航 -->
        <div class="nav">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>
              <span class="el-icon-s-home"></span>
              <a href="/">首页</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <a href="/">科技贷</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="bc_info">
          <!--背景介绍（左）  -->
          <div class="introLeft">
            <h3 class="hbold">背景介绍</h3>
            <div class="bcEnglish">BACKGROUND</div>
            <p class="txt1">{{txt1}}</p>
          </div>
          <!--背景介绍（右）  -->
          <div class="introRight">
            <div class="imgcontainer">
              <video
                @ended="videoOver"
                @pause="videoPause"
                @play="videoP"
                ref="videoPlay"
                src="../../../public/科技贷.mp4"
                :controls="flag"
              ></video>
              <img
                ref="play"
                src="../../assets/Home/shipinbofang.png"
                alt
                class="play"
                @click="onPlay"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 业务优势 -->
    <div class="advantage">
      <div class="container">
        <h3 class="hbold">业务优势</h3>
        <ul>
          <li v-for="(i,n) in advantageList" :key="n">
            <img :src="i.img" alt />
            <div class="htitle">
              <h4 v-html="i.title"></h4>
            </div>
            <p v-html="i.explain"></p>
            <p v-html="i.explain1"></p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 性质 -->
    <div class="nature">
      <div class="container">
        <h3 class="hbold">科技贷的性质、额度、期限及还款方式</h3>
        <ul>
          <li v-for="(i,n) in natureList" :key="n">
            <img :src="i.img" alt />
            <p class="label">{{i.label}}</p>
            <p class="txt2">{{i.txt2}}</p>
          </li>
        </ul>
        <div class="explain">
          <p class="explain1">解释说明</p>
          <p class="explain2">同一家企业可以通过两家合作银行申请科技贷，最高可申请至2000万元。</p>
        </div>
      </div>
    </div>
    <!--  入准要求-->
    <div class="request">
      <div class="container">
        <h3 class="hbold">企业准入要求</h3>
        <ul>
          <li
            v-for="(i, n) in reqList"
            :key="n"
            :class="TabIndex == n ? 'focusTab' : ''"
            @mouseenter="mouseEnter(n)"
            @mouseleave="mouseLeave()"
          >
            <p class="num">{{i.num}}</p>
            <!-- <img :src="TabIndex == n ? i.img1 : i.img"  alt="" />
         
            <h3>{{ i.title }}</h3>-->
            <p class="txt3">{{i.txt3}}</p>
          </li>
        </ul>
        <!-- <div class="explain">
        <p class="explain1">解释说明</p>
        <p class="explain2">前五条的要求属于科技贷的一般要求，第六、七条属于银行的准入要求及审批要求。</p>
        </div>-->
      </div>
    </div>
    <!-- 合作银行 -->
    <div class="banks">
      <div class="container">
        <h3 class="hbold">合作银行</h3>
        <p>科技厅自2016年开始，公开遴选了三批共16家合作银行</p>
        <ul>
          <li v-for="(i,n) in bankList" :key="n">
            <img :src="i.img" alt />
          </li>
        </ul>
        <div class="explain">
          <p class="explain2">目前，交通银行、广发银行、华夏银行是第三批入围银行，未签订科技贷合作协议，不能开展业务。</p>
        </div>
      </div>
    </div>
    <!-- 专业机构 -->
    <div class="institutions">
      <div class="container">
        <h3 class="hbold">专业机构</h3>
        <p>2017年3月22日，河南省生产力促进中心被河南省科技厅认定为河南省科技金融“科技贷”业务的专业机构。</p>
      </div>
    </div>
    <!-- 业务流程 -->
    <div class="process">
      <div class="container">
        <h3 class="hbold">业务流程</h3>
        <ul class="ul1">
          <li v-for="(i,n) in processList" :key="n">
            <img :src="i.img" alt />
            <p>{{i.txt4}}</p>
          </li>
        </ul>
        <ul class="ul2">
          <li v-for="(i,n) in 5" :key="n">
            <img src="../../assets/Home/蒙版组 72@2x.png" alt />
          </li>
        </ul>
      </div>
    </div>
    <!-- 注意事项 -->
    <div class="tips">
      <div class="container">
        <div class="tipLeft">
          <h3 class="hbold">全省业务开展情况</h3>
          <p>
            2019年全省科技贷放款
            <span class="num1">12.11</span>亿；
          </p>
          <p>
            截至2020年9月底，全省科技贷放款约
            <span class="num1">12</span> 亿。
          </p>
        </div>
        <div class="tipRight">
          <h3 class="hbold">其他说明事项</h3>
          <div class="top">
            <span>（1）</span>
            <p>企业考虑成本的话，会把现有银行贷款成本高的产品，置换成科技贷产品，降低企业的融资成本。目前中国银行的成本相对较低。</p>
          </div>
          <div class="down">
            <span>（2）</span>
            <p>如果企业没有抵押物，可考虑在郑州银行、邮储银行申请300万以内的科技贷。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      txt1: '2016年3月，河南省科技厅联合财政厅制定《河南省科技金融“科技贷”业务实施方案》，通过设立科技信贷准备金的机制，补偿合作银行为科技型中小企业贷款后所发生的损失，引导商业银行降低科技型中小企业贷款实物资产抵质押要求，主要利用自主知识产权、股权等无形资产以非变现质押方式给予贷款支持，着重解决科技型中小企业贷款难的问题。',
      flag: false,
      advantageList: [
        {
          img: require('../../assets/Home/蒙版组 54@2x.png'),
          title:
            '实物资产抵质押不高于贷款金额的30%<br>对单一实物资产超过贷款额30%的情况予以例外',
          explain:
            '<b>解释说明：</b>如果企业可以新增授信1000万元，通过“科技贷”业务，只需要匹配一套评估价值约300万的抵押物。如果企业只有一套合适的抵押物，不可分割，评估价值超过300万，这种情况下的抵押物是可以用的。',
          explain1:
            '目前，郑州银行、邮储银行对于300万以内的科技贷，可以实现无实物抵押的信用放款。',
        },
        {
          img: require('../../assets/Home/蒙版组 55@2x.png'),
          title: '贷款利率不超过同期人民银行基准贷款利率的1.3倍',
          explain:
            '<b>解释说明：</b>目前人民银行基准贷款利率一年期的是4.35%，1.3倍是5.655%。',
          explain1:
            ' 今年疫情大形势下，各家合作银行的科技贷利率目前一般在4%-5.655%之间，根据企业的情况具体而定。',
        },
      ],
      natureList: [
        {
          img: require('../../assets/Home/蒙版组 22@2x.png'),
          label: '性质',
          txt2: '科技贷应用于企业的生产经营，属于流动资金贷款。',
        },
        {
          img: require('../../assets/Home/蒙版组 23@2x.png'),
          label: '额度',
          txt2: '科技贷单笔最高额度是1000万元。',
        },
        {
          img: require('../../assets/Home/蒙版组 24@2x.png'),
          label: '期限',
          txt2: '科技贷的期限一般是一年。',
        },
        {
          img: require('../../assets/Home/蒙版组 25@2x.png'),
          label: '还款方式',
          txt2: '还款方式一般是按月付息，到期还本。',
        },
      ],
      reqList: [
        {
          num: '01',
          txt3: '国家科技型中小企业、高新技术企业和河南省科技型中小企业等科技型企业，符合其中一类即可申请科技贷。',
        },
        {
          num: '02',
          txt3: '主营业务清晰，经营财务状况正常，企业及其主要股东或实际控制人无不良记录（包括纳税记录、个人征信、企业征信等）。',
        },
        { num: '03', txt3: '不涉及对企业经营存在重大影响的法律纠纷。' },
        { num: '04', txt3: '不属于国家政策规定的属于限制或者淘汰的行业。' },
        { num: '05', txt3: '原则上不涉及互保联保、对外担保及民间融资。' },
      ],
      TabIndex: 0,
      bankList: [
        { img: require('../../assets/Home/蒙版组 56@2x.png') },
        { img: require('../../assets/Home/蒙版组 57@2x.png') },

        { img: require('../../assets/Home/蒙版组 59@2x.png') },
        { img: require('../../assets/Home/蒙版组 58@2x.png') },
        { img: require('../../assets/Home/蒙版组 60@2x.png') },
        { img: require('../../assets/Home/蒙版组 62@2x.png') },
        { img: require('../../assets/Home/蒙版组 61@2x.png') },
        { img: require('../../assets/Home/蒙版组 63@2x.png') },
        { img: require('../../assets/Home/蒙版组 64@2x.png') },
        { img: require('../../assets/Home/蒙版组 66@2x.png') },
        { img: require('../../assets/Home/蒙版组 65@2x.png') },
        { img: require('../../assets/Home/蒙版组 67@2x.png') },
        { img: require('../../assets/Home/蒙版组 68@2x.png') },
        { img: require('../../assets/Home/蒙版组 70@2x.png') },
        { img: require('../../assets/Home/蒙版组 69@2x.png') },
        { img: require('../../assets/Home/蒙版组 71@2x.png') },
      ],
      processList: [
        {
          img: require('../../assets/Home/组 534@2x.png'),
          txt4: '国家高新技术企业或者科技型中小企业',
        },
        {
          img: require('../../assets/Home/组 535@2x.png'),
          txt4: '通过“河南省科技金融在线服务平台”填报“科技贷”融资申请',
        },
        {
          img: require('../../assets/Home/组 536@2x.png'),
          txt4: '银行和专业机构经过现场调查、审核',
        },
        {
          img: require('../../assets/Home/组 537@2x.png'),
          txt4: '银行和专业机构审核通过后，向省科研生产试验基地管理服务中心备案',
        },
        {
          img: require('../../assets/Home/组 538@2x.png'),
          txt4: '基地管理服务中心备形式审核后，出具确认函，予以纳入“科技贷”管理',
        },
        {
          img: require('../../assets/Home/组 539@2x.png'),
          txt4: '银行依据确认函放款',
        },
      ],
    }
  },
  methods: {
    mouseEnter(n) {
      this.TabIndex = n
      //  // console.log(n)
    },
    //   鼠标移除
    mouseLeave() {
      this.TabIndex = null
    },
    onPlay() {
      this.$refs.videoPlay.play()
      this.$refs.play.style.display = 'none'
      this.flag = true
    },
    videoOver() {
      this.$refs.play.style.display = 'block'
      this.flag = false
    },
    videoPause() {
      this.$refs.play.style.display = 'block'
    },
    videoP() {
      this.$refs.play.style.display = 'none'
    },
  },
}
</script>

<style  lang="scss" scoped>
.scienceLoan {
  width: 100%;
  font-size: 1rem;
  color: #666666;
  font-family: Microsoft YaHei;
  .container {
    width: 87.5rem;
    margin: 0 auto;
  }
  /* 背景介绍 */
  .Background_intro {
    background: #ffffff;
    .nav {
      padding: 1.5625rem 0 1.25rem 0;
    }
    .bc_info {
      display: flex;
      justify-content: space-around;
      margin-bottom: 2.875rem;
    }
    .introLeft {
      position: relative;
      margin-top: 1.875rem;
      h3 {
        width: 27.9375rem;
        /* height: 5.25rem; */
        line-height: 5.25rem;
        text-align: start;
        font-size: 2.375rem;
        color: #333333;
        margin-left: -2.875rem;
        font-weight: bold;
      }
      .bcEnglish {
        width: 27.9375rem;
        /* height: 5.25rem; */
        position: absolute;
        top: 0;
        left: 0;
        text-align: start;
        font-size: 3.75rem;
        font-family: PingFang SC;
        /* font-weight: 800; */
        /* line-height: 0px; */
        color: #273b55;
        /* letter-spacing: 2.5rem; */
        opacity: 0.05;
      }
      .txt1 {
        margin-top: 2.5rem;
        margin-left: -2.875rem;
        text-indent: 2rem;
        line-height: 2.375rem;
        font-size: 1.125rem;
        text-align: start;
        width: 39.125rem;
        /* height: 14.75rem; */
      }
    }
    .imgcontainer {
      cursor: pointer;
      width: 40.5625rem;
      padding: 1.5625rem 0 0.5625rem;
      position: relative;
      video {
        width: 40.5625rem;
        height: 22.8125rem;
      }
      .play {
        position: absolute;
        top: 38%;
        left: 42%;
        z-index: 2000;
        width: 5rem;
      }
    }
  }
  /* 业务优势 */
  .advantage {
    overflow: hidden;
    background: #f9f9f9;
    h3 {
      margin: 3.625rem 0 3.125rem;
      font-size: 2.375rem;
      color: #333333;
      font-weight: bold;
    }
    ul {
      display: flex;
      text-align: start;
      /* justify-content: space-around; */
      li {
        width: 42.6875rem;
        /* height: 23.125rem; */
        margin-right: 2.1875rem;
        background: #ffffff;
        margin-bottom: 3.875rem;
        padding-bottom: 2.1875rem;
        img {
          margin-top: 2.1875rem;
          margin-left: 2.5625rem;
          width: 3.75rem;
          height: 3.75rem;
        }
        .htitle {
          height: 3.875rem;
          margin-top: 1.25rem;
          margin-bottom: 1.25rem;
          h4 {
            margin-top: 0;
            margin-bottom: 0;
            line-height: 1.9375rem;
            color: #333333;
            /* padding-top:-0.25rem;
          padding-bottom:-0.25rem; */
            font-size: 1.125rem;
            /* margin-top: 1.870313rem;
          margin-bottom: 1.870313rem; */
            margin-left: 2.5625rem;
            font-weight: bold;
          }
        }

        p {
          line-height: 1.6rem;
          margin-right: 2.5625rem;
          margin-left: 2.5625rem;
          margin-bottom: 0.625rem;
        }
      }
    }
  }
  /* 性质 */
  .nature {
    background: #ffffff;
    h3 {
      margin: 3.75rem 0 3.125rem;
      font-size: 2.375rem;
      color: #333333;
      font-weight: bold;
    }
    ul {
      display: flex;
      margin-top: 0.3125rem;
      justify-content: space-around;
      li {
        margin-right: 11.25rem;
        img {
          width: 3.75rem;
          height: 3.75rem;
        }
        .label {
          font-weight: bold;
          color: #333333;
          font-size: 1.125rem;
          margin-bottom: 1.5rem;
        }
        .txt2 {
          /* text-align: start; */
          font-size: 1rem;
          width: 11.25rem;
          /* height: 3rem; */
          color: #8b8b8b;
        }
      }
    }
    .explain {
      margin-top: 3.25rem;
      margin-bottom: 3.625rem;
      p {
        display: inline-block;
        font-size: 0.9375rem;
        font-size: 0.9375rem;
        padding: 0.375rem 0.9375rem;
      }
      .explain1 {
        text-align: center;
        color: #ffffff;
        border: 0.0625rem solid #fe952a;
        border-radius: 0.125rem 0 0 0.125rem;
        background: #fe952a;
      }
      .explain2 {
        color: #fe952a;
        background: #fff8f2;
        border: 0.0625rem solid #fe952a;
        border-radius: 0.125rem;
      }
    }
  }
  /* 要求 */
  .request {
    overflow: hidden;
    background: #f9f9f9;

    .container {
      h3 {
        font-size: 2.375rem;
        color: #333333;
        margin-top: 3.75rem;
        margin-bottom: 3.75rem;
        font-weight: bold;
      }
      .explain {
        margin-top: 3.5rem;
        margin-bottom: 4.125rem;

        p {
          display: inline-block;
          font-size: 0.9375rem;
          font-size: 0.9375rem;
          padding: 0.375rem 0.9375rem;
        }
        .explain1 {
          text-align: center;
          color: #ffffff;
          border: 0.0625rem solid #fe952a;
          border-radius: 0.125rem 0px 0px 0.125rem;
          background: #fe952a;
        }
        .explain2 {
          color: #fe952a;
          background: #fff8f2;
          border: 0.0625rem solid #fe952a;
          border-radius: 0.125rem;
        }
      }
      ul {
        display: flex;
        justify-content: space-around;
        .focusTab {
          background: #3667d8;
          .num {
            position: relative;
            font-size: 1.875rem;
            color: #ffffff;
            text-align: start;
            margin-top: 2.1875rem;
            margin-left: 1.5625rem;
            margin-bottom: 0.75rem;
          }
          .num:after {
            position: absolute;
            top: 3.5rem;
            left: 0;
            clear: both;
            content: '';
            border-top: 0.0625rem solid;
            width: 1.4375rem;
            height: 0.25rem;
            background: #ffffff;

            opacity: 0.9;
            border-radius: 0.0625rem;
          }
          .txt3 {
            margin-left: 1.1rem;
            margin-top: 3.625rem;
            color: #ffffff;
            line-height: 1.75rem;
            clear: both;
            width: 8.75rem;
            /* height: 11.1875rem; */
            margin-bottom: 2.25rem;
          }
        }

        li {
          width: 12.0625rem;
          /* height: 21.25rem; */
          margin-right: 0.5625rem;

          background: #ffffff;

          .num {
            position: relative;
            font-size: 1.875rem;
            color: #3667d8;
            text-align: start;
            margin-top: 2.1875rem;
            margin-left: 1.5625rem;
            margin-bottom: 0.75rem;
          }
          .num:after {
            position: absolute;
            top: 3.5rem;
            left: 0;
            clear: both;
            content: '';
            border-top: 0.0625rem solid;
            width: 1.4375rem;
            height: 0.25rem;
            background: #3667d8;
            opacity: 0.9;
            border-radius: 0.0625rem;
          }
          .txt3 {
            margin-left: 1.1rem;
            margin-top: 3.625rem;
            margin-bottom: 2.25rem;
            line-height: 1.75rem;
            clear: both;
            width: 8.75rem;
            /* height: 11.1875rem; */
          }
        }
      }
    }
  }
  .banks {
    h3 {
      margin: 3.625rem 0 1.3125rem;
      font-size: 2.375rem;
      color: #333333;
      font-weight: bold;
    }
    p {
      color: #999999;
      font-family: PingFang SC;
      font-size: 1.125rem;
    }
    .explain {
      margin-top: 1rem;
      margin-bottom: 5.375rem;
      p {
        display: inline-block;
        font-size: 0.9375rem;
        padding: 0.375rem 0.9375rem;
      }

      .explain2 {
        color: #fe952a;
        background: #fff8f2;
        border: 0.0625rem solid #fe952a;
        border-radius: 0.125rem;
      }
    }
    ul {
      margin-top: 3.125rem;
      justify-content: space-around;
      display: flex;
      flex-wrap: wrap;
      li {
        /* width: 16.25rem;
         height: 5rem; */
        margin-right: 5.5rem;
        margin-bottom: 3.125rem;
        img {
          width: 16.25rem;
          height: 5rem;
        }
      }
    }
    background: #ffffff;
  }
  .institutions {
    overflow: hidden;
    background: url('../../assets/Home/蒙版组 28@2x.png') no-repeat center;

    h3 {
      font-size: 2.375rem;
      color: #333333;
      margin-top: 4.25rem;
      margin-bottom: 2.4375rem;
      color: #ffffff;
    }
    p {
      color: #ffffff;
      font-size: 1.25rem;
      /* width: 75rem; */
      height: 3.75rem;
      /* margin-left:22.5rem ;
    margin-right:22.5rem ; */
      margin-bottom: 2.6875rem;
      opacity: 0.65;
    }
  }
  .process {
    overflow: hidden;
    position: relative;
    h3 {
      font-size: 2.375rem;
      color: #333333;
      margin-top: 3.625rem;
      margin-bottom: 3.75rem;
      font-weight: bold;
    }
    ul {
      display: flex;
      width: 87.5rem;
      /* justify-content: space-around; */
    }
    .ul1 {
      li {
        margin-right: 5.75rem;
        img {
          margin: 0 1.875rem 0.9375rem 1.875rem;
          width: 5rem;
          height: 5rem;
        }
        p {
          text-align: start;
          width: 8.75rem;
          /* height: 6.875rem; */
          margin-bottom: 3.875rem;
        }
      }
    }
    .ul2 {
      position: absolute;
      top: 12.2rem;
      left: 25.875rem;
      li {
        margin-right: 11.75rem;
        img {
          width: 2.75rem;
          height: 1.125rem;
        }
      }
    }
  }
  .tips {
    overflow: hidden;
    background: url('../../assets/Home/组 125@2x.png') no-repeat center;
    .container {
      display: flex;
      justify-content: space-around;
      margin-bottom: 10.25rem;
    }
    h3 {
      text-align: start;
      font-size: 2rem;
      font-weight: bold;
      color: #333333;
      margin-top: 3.75rem;
      margin-bottom: 3.3125rem;
    }
    p {
      text-align: start;
      color: #273b55;
    }
    .tipLeft {
      margin-right: 20.4375rem;
      p {
        font-size: 1.25rem;
        width: 29.625rem;
        line-height: 2.8125rem;
      }
      .num1 {
        font-size: 1.875rem;
        color: #3667d8;
      }
    }
    .tipRight {
      div {
        width: 35.9375rem;
        display: flex;
        line-height: 2.3125rem;
        font-size: 1.25rem;
      }
    }
  }
}
.hbold {
  font-weight: bold;
}
</style>